import gql from 'graphql-tag';
import { WalletFragment } from '../fragments/wallet.fragment';

export const FIND_OR_CREATE_MAIN_CREDIT_WALLET = gql`
    mutation(
        $userId: String!
    ) {
        findOrCreateMainCreditWallet(
            userId: $userId
        ) {
            ...WalletInfo
        }
    }
    ${WalletFragment}
`;